module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-14.c163c582.png";